<!--  -->
<template>
    <div class='left1_container box_v'>
        <div class="title1">收集问题</div>
        <div class="content box box_f1">
            <div v-for="(item,index) in list" :key="`collect_${index}`" class="item">
                <div class="inner_tr box box_between">
                    <div class="title box">{{item.typeName}}</div>
                    <div class="number box">{{item.count}}件</div>
                </div>
                <div class="line_bg">
                    <div class="line" :style="{width:item.width}"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.collectNumberByType).then(res=>{
                let max = res.rows[0].count
                this.list = res.rows.map(item=>{
                    return{
                        ...item,
                        count:item.count.toLocaleString(),
                        width:(item.count/max)*100 + '%'
                    }
                })
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.left1_container{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftup.png');
    background-size: 100% 100%;
    height:100%;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:20px 0 0 40px
}
.content{
    padding:5px 20px 0 20px;
    flex-wrap: wrap;
    .item{
        width:46%;
        height:20%;
        align-items: flex-start
        //margin-bottom:10px
    }
    .item:nth-child(odd){
        margin-right:4%
    }
    .item:nth-child(even){
        margin-left:4%
    }
    .inner_tr{
        width:100%;
        align-items: flex-end
    }
    .title{
        font-size: 14px;
        color: #23E0F1;
    }
    .number{
        text-align: right;
        font-size: 18px;
        font-weight: bold;
        font-style: italic;
        color: #FFFFFF;
        background: linear-gradient(0deg, #00F6FF 0%, #0290FE 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        padding-right:4px;
    }
    .line_bg{
        width: 100%;
        height: 9px;
        background: #1D3370;
        border-radius: 5px;
    }
    .line{
        height: 9px;
        background: linear-gradient(90deg, #00F6FF 0%, #0290FE 100%);
        border-radius: 5px;
    }
}
</style>